
export interface IRfqMetaPlugin {
    readonly disableSubmit: boolean;
    readonly canSubmit: boolean;
    readonly formHasMultiplePages: boolean;
    getMetaModel: () => Promise<any>;
    isValid: () => Promise<boolean>;
    validate: () => void;
}

export interface SaveRequestForQuoteMetaResponse {
    quoteUrl: string;
}

export interface ValidateQuoteForInputResponse {
    quoteGuid: string;
    productId: number;
    status: number;
    isValid: boolean;
}

export enum QuoteLineStatusEnum {
    Initial = 1,
    Fulfilled = 2,
    Failed = 3,
    Canceled = 4
}